// extracted by mini-css-extract-plugin
export default {"client_card":"ClientCard_client_card__FWZIB"};